import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import {SOURCE_TYPE} from "../constants/Tpiq.constants";

export function getFormulaTestCasesUrl(org, userId) {
  return `/TaxPlanningServices/orgs/${org}/users/${userId}/formula-test-cases`;
}

@Injectable({
  providedIn: 'root'
})
export class FormulaTestCaseService extends TaxplanIQServices {

  constructor(http: HttpClient) {
    super(http);
  }

  getTestCases(org, userId, params: {
    page: number; pageSize: number; search?: string;
    formulaType?: string; lastRunStatus?: string; status?: string;
  }): Observable<any> {
    let url = `${getFormulaTestCasesUrl(org, userId)}?page=${params.page}&pageSize=${params.pageSize}`;
    if (params.search) {
      url += `&search=${encodeURIComponent(params.search)}`;
    }
    if (params.formulaType) {
      url += `&formulaType=${params.formulaType}`;
    }
    if (params.lastRunStatus) {
      url += `&lastRunStatus=${params.lastRunStatus}`;
    }
    if (params.status) {
      url += `&status=${params.status}`;
    }
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  saveTestCase(org, userId, testCase): Observable<any> {
    return this.create(getFormulaTestCasesUrl(org, userId), testCase, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  deleteTestCase(org, userId, id): Observable<any> {
    const url = `${getFormulaTestCasesUrl(org, userId)}/${id}`;
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  runTestCase(org, userId, id): Observable<any> {
    const url = `${getFormulaTestCasesUrl(org, userId)}/${id}/run`;
    return this.create(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  runAllTestCases(org, userId, dryRun = false): Observable<any> {
    const url = `${getFormulaTestCasesUrl(org, userId)}/run-all${dryRun ? '?dryRun=true' : ''}`;
    return this.create(url, {}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  evaluateSandbox(org, userId, payload): Observable<any> {
    const url = `${getFormulaTestCasesUrl(org, userId)}/evaluate`;
    return this.create(url, payload, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateRuleFormula(org, userId, ruleId, payload: {formulaType: string; formula: string}): Observable<any> {
    const url = `${getFormulaTestCasesUrl(org, userId)}/rules/${ruleId}/formula`;
    return this.update(url, payload, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAvailableRules(org, userId): Observable<any> {
    const url = `${getFormulaTestCasesUrl(org, userId)}/available-rules`;
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getRunHistory(org, userId, id): Observable<any> {
    const url = `${getFormulaTestCasesUrl(org, userId)}/${id}/history`;
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  checkInternalAccess(org, userId): Observable<any> {
    const url = `${getFormulaTestCasesUrl(org, userId)}/internal-access`;
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  setActive(org, userId, id, active): Observable<any> {
    const url = `${getFormulaTestCasesUrl(org, userId)}/${id}/active`;
    return this.update(url, {active}, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): any {
    return throwError(error.error);
  }

}
